import { createContext } from 'react';
var CommonPropsContext = createContext({});
export default CommonPropsContext;
//# sourceMappingURL=CommonPropsContext.js.mapimport { createContext } from 'react';
var CommonPropsContext = createContext({});
export default CommonPropsContext;
//# sourceMappingURL=CommonPropsContext.js.map